import * as React from 'react';

import AdminNoticeBanner from 'admin/components/AdminNoticeBanner';
import AdminSchoolSisSyncHeader from 'admin/rostering/components/AdminSchoolSisSyncHeader';
import EventTracking from 'lib/EventTracking';

type Props = {
  orgUuid: string;
};

export default function AdminSisSyncInReviewView(props: Props) {
  // because the second argument will never change the array values,
  //   it will only trigger once like componentWillMount.
  // https://dev.to/trentyang/replace-lifecycle-with-hooks-in-react-3d4n
  React.useEffect(() => {
    EventTracking.view('rostering.sis_dash.in_review.viewed', {
      organization_uud: props.orgUuid,
    });
  }, []);

  return (
    <section className="AdminSisSyncInReviewView">
      <AdminSchoolSisSyncHeader subtext={''} status="pending" />
      <AdminNoticeBanner glyph="clock" color="sunrise" actionElement={null}>
        Your district's sync is currently in progress. Please reach out to a district administrator
        for updates.
      </AdminNoticeBanner>
    </section>
  );
}
